<template>
  <div>
    <Card title="Add App to Household" icon="mdi-view-grid-plus">
      <v-btn
        @click="createListDialog = true"
        height="72" width="72" class="mx-2 my-4" color="#F9A825">
        <v-flex>
          <div class="d-flex justify-center"><v-icon x-large>mdi-clipboard-check-multiple</v-icon></div>
          <div class="caption text-truncate" style="max-width: 72px;">Lists</div>
        </v-flex>
      </v-btn>
      <v-btn
        @click="createNewtonDialog = true"
        text height="72" width="72" class="mx-2 my-4">
        <v-flex>
          <div class="d-flex justify-center"><v-icon x-large>mdi-router-network</v-icon></div>
          <div class="caption text-truncate" style="max-width: 72px;">Newton</div>
        </v-flex>
      </v-btn>
      <v-btn
        @click="createFinancialModuleDialog = true"
        height="72" width="72" class="mx-2 my-4" color="#084f09">
        <v-flex>
          <div class="d-flex justify-center"><v-icon x-large>mdi-currency-usd</v-icon></div>
          <div class="caption text-truncate" style="max-width: 72px;">Financial</div>
        </v-flex>
      </v-btn>
      <v-btn
        @click="createPropertyHolderDialog = true"
        height="72" width="72" class="mx-2 my-4" color="#8B5E34">
        <v-flex>
          <div class="d-flex justify-center"><v-icon x-large>mdi-home-city</v-icon></div>
          <div class="caption text-truncate" style="max-width: 72px;">Properties</div>
        </v-flex>
      </v-btn>
      <v-btn
        @click="createVehicleHolderDialog = true"
        height="72" width="72" class="mx-2 my-4" color="#2F5D8C">
        <v-flex>
          <div class="d-flex justify-center"><v-icon x-large>mdi-car-multiple</v-icon></div>
          <div class="caption text-truncate" style="max-width: 72px;">Vehicles</div>
        </v-flex>
      </v-btn>
      <v-btn
        @click="createAIAssistantDialog = true"
        height="72" width="72" class="mx-2 my-4" color="#082E4F">
        <v-flex>
          <div class="d-flex justify-center"><v-icon x-large>$smartHome</v-icon></div>
          <div class="caption text-truncate" style="max-width: 72px;">AI</div>
        </v-flex>
      </v-btn>
      <v-btn
        @click="createCalendarsDialog = true"
        height="72" width="72" class="mx-2 my-4" color="#1E3A8A">
        <v-flex>
          <div class="d-flex justify-center"><v-icon x-large>mdi-calendar-multiple</v-icon></div>
          <div class="caption text-truncate" style="max-width: 72px;">Calendar</div>
        </v-flex>
      </v-btn>
      <v-btn
        @click="createCloudIntegrationDialog = true"
        height="72" width="72" class="mx-2 my-4">
        <v-flex>
          <div class="d-flex justify-center"><v-icon x-large>mdi-cloud-outline</v-icon></div>
          <div class="caption text-truncate" style="max-width: 72px;">Integration</div>
        </v-flex>
      </v-btn>
      <v-btn
        @click="createTimersDialog = true"
        height="72" width="72" class="mx-2 my-4" color="#1E3A8A">
        <v-flex>
          <div class="d-flex justify-center"><v-icon x-large>mdi-timer</v-icon></div>
          <div class="caption text-truncate" style="max-width: 72px;">Timers</div>
        </v-flex>
      </v-btn>
<!--      <v-btn-->
<!--        @click="createTimerDialog = true"-->
<!--        text height="72" width="72" class="mx-2 my-4">-->
<!--        <v-flex>-->
<!--          <div class="d-flex justify-center"><v-icon x-large>mdi-clock-outline</v-icon></div>-->
<!--          <div class="caption text-truncate" style="max-width: 72px;">Timer</div>-->
<!--        </v-flex>-->
<!--      </v-btn>-->
    </Card>
    <v-dialog v-model="createListDialog" max-width="1023">
      <Card title="Create a new set of lists" icon="mdi-clipboard-check-multiple" inDialog>
        <DynamicForm
          :key="createListDialog"
          :object="{name: ''}"
          :fields="[{fieldName:'name', displayName:'Name', placeholder:'Shopping Lists', type: String, rules:[rules.required]}]"
          :save-method="(data) => this.$api.list.createListHolder(household.id, data.name)"
          :cancel-callback="() => this.createListDialog = false"
          :success-callback="(o) => {this.createListDialog = false; $router.push('/h/' + household.id + '/list/' + o.id)}"
          :focus-index="0"
        ></DynamicForm>
      </Card>
    </v-dialog>
    <v-dialog v-model="createNewtonDialog" max-width="1023">
      <Card title="Connect a Newton Device" icon="mdi-clipboard-check-multiple" inDialog>
        <DynamicForm
          :key="createNewtonDialog"
          :object="{name: ''}"
          :fields="[{fieldName:'code', displayName:'Code', placeholder:'', type: String, rules:[rules.required, rules.sixDigits]}]"
          :save-method="(data) => this.$api.newton.connectNewtonToHousehold(household.id, data.code)"
          :cancel-callback="() => this.createNewtonDialog = false"
          :success-callback="(o) => {this.createNewtonDialog = false; $router.push('/h/' + household.id + '/newton/' + o.id)}"
          :focus-index="0"
        ></DynamicForm>
      </Card>
    </v-dialog>
    <v-dialog v-model="createFinancialModuleDialog" max-width="1023">
      <Card title="Create a Financial App" icon="mdi-currency-usd" inDialog>
        <DynamicForm
          :key="createFinancialModuleDialog"
          :object="{name: 'Financial'}"
          :fields="[
            {fieldName:'name', displayName:'Name', placeholder:'Financial', type: String, rules:[rules.required]},
            {fieldName:'createEnvelopes', displayName:'Create envelopes from template', type: Boolean},
            ]"
          :save-method="(data) => this.$api.financial.createFinancialModule(household.id, data.name, data.createEnvelopes)"
          :cancel-callback="() => this.createFinancialModuleDialog = false"
          :success-callback="(o) => {this.createFinancialModuleDialog = false; $router.push('/h/' + household.id + '/f/' + o.id)}"
          :focus-index="0"
        ></DynamicForm>
      </Card>
    </v-dialog>
    <v-dialog v-model="createPropertyHolderDialog" max-width="1023">
      <Card title="Create a Property App" icon="mdi-home-city" inDialog>
        <DynamicForm
          :key="createPropertyHolderDialog"
          :object="{name: 'Properties'}"
          :fields="[{fieldName:'name', displayName:'Name', type: String, rules:[rules.required]}]"
          :save-method="(data) => this.$api.rpc('property', 'createPropertyHolder', {householdId: household.id, name: data.name})"
          :cancel-callback="() => this.createPropertyHolderDialog = false"
          :success-callback="(o) => {this.createPropertyHolderDialog = false; $router.push('/h/' + household.id + '/property/' + o.id)}"
          :focus-index="0"
        ></DynamicForm>
      </Card>
    </v-dialog>
    <v-dialog v-model="createVehicleHolderDialog" max-width="1023">
      <Card title="Create a Vehicle App" icon="mdi-car-multiple" inDialog>
        <DynamicForm
          :key="createVehicleHolderDialog"
          :object="{name: 'Vehicles'}"
          :fields="[{fieldName:'name', displayName:'Name', type: String, rules:[rules.required]}]"
          :save-method="(data) => this.$api.rpc('vehicle', 'createVehicleHolder', {householdId: household.id, name: data.name})"
          :cancel-callback="() => this.createVehicleHolderDialog = false"
          :success-callback="(o) => {this.createVehicleHolderDialog = false; $router.push('/h/' + household.id + '/vehicle/' + o.id)}"
          :focus-index="0"
        ></DynamicForm>
      </Card>
    </v-dialog>
    <v-dialog v-model="createTimerDialog" max-width="1023">
      <Card title="Connect a Timer" icon="mdi-clipboard-check-multiple" inDialog>
        <DynamicForm
          :key="createTimerDialog"
          :object="{name: ''}"
          :fields="[{fieldName:'code', displayName:'Code', placeholder:'', type: String, rules:[rules.required, rules.sixDigits]}]"
          :save-method="(data) => this.$api.newton.connectNewtonToHousehold(household.id, data.code)"
          :cancel-callback="() => this.createTimerDialog = false"
          :success-callback="(o) => {this.createTimerDialog = false; $router.push('/h/' + household.id + '/timer/' + o.id)}"
          :focus-index="0"
        ></DynamicForm>
      </Card>
    </v-dialog>
    <v-dialog v-model="createAIAssistantDialog" max-width="1023">
      <Card title="Create an AI Assistant!" icon="$smartHome" inDialog>
        <DynamicForm
          :key="String(createAIAssistantDialog) + ':' + String(aiPresetOptions.length)"
          :object="{name: household.name + ' AI', presetType: aiPresetOptions.length > 0 ? aiPresetOptions[0].value : null, personality: aiPersonalityPresets.length > 0 ? aiPersonalityPresets[0].personality : 'Dryly witty, observant, warm, and a little opinionated without becoming abrasive.', recurringBehavior: aiPersonalityPresets.length > 0 ? aiPersonalityPresets[0].recurringBehavior : 'Notices relevant timing, routines, unfinished threads, and repeated preferences without becoming overbearing.', modules: {}}"
          :fields="[
            {fieldName:'name', displayName:'Name', placeholder:'', type: String, rules:[rules.required]},
            {fieldName:'presetType', displayName:'Preset', type: 'Enumerator', values: aiPresetOptions, clearable: true},
            {fieldName:'personality', displayName:'Personality notes', placeholder:'Dry, affectionate, mildly sarcastic, notices routines, keeps answers tight...', type: 'LargeTextBox', hint:'Describe the assistant\'s vibe, tone, and recurring tendencies. This is stronger than wording preferences; it shapes how the AI reacts.', maxlength: 4000},
            {fieldName:'recurringBehavior', displayName:'Recurring behavior', placeholder:'Gently notices lateness, remembers unfinished threads, occasionally teases about recurring patterns...', type: 'LargeTextBox', hint:'Use this for habits and bits the AI can repeat over time. Keep it bounded so it stays charming instead of exhausting.', maxlength: 4000},
            {fieldName:'modules', displayName:'AIs can access multiple modules across multiple households. What do you want to give this AI access to?', placeholder:'', type: 'HOASubModules', rules:[rules.required]},
            ]"
          :save-method="(data) => this.$api.ai.createNewAI(data.name, data.personality, data.recurringBehavior, data.modules)"
          @presetTypechange="applyAIPreset"
          :cancel-callback="() => this.createAIAssistantDialog = false"
          :success-callback="(o) => {this.createAIAssistantDialog = false; $router.push('/ai/' + o.id)}"
          :focus-index="0"
        ></DynamicForm>
      </Card>
    </v-dialog>
    <v-dialog v-model="createCalendarsDialog" max-width="1023">
      <Card title="Create a set of Calendars" icon="mdi-calendar-multiple" inDialog>
        <DynamicForm
          :key="createCalendarsDialog"
          :object="{name: 'Calendars'}"
          :fields="[
            {fieldName:'name', displayName:'Name', placeholder:'', type: String, rules:[rules.required]},
            ]"
          :save-method="(data) => this.$api.calendar.createCalendarHolder(household.id, data.name)"
          :cancel-callback="() => this.createCalendarsDialog = false"
          :success-callback="(o) => {this.createCalendarsDialog = false; $router.push('/h/' + household.id + '/calendar/' + o.id)}"
          :focus-index="0"
        ></DynamicForm>
      </Card>
    </v-dialog>
    <v-dialog v-model="createCloudIntegrationDialog" max-width="1023">
      <Card title="Connect to a Cloud Integration" icon="mdi-cloud-outline" inDialog>
        <DynamicForm
          :key="createCloudIntegrationDialog"
          :object="{type: null, name: 'My Cloud Integration', username: '', password: ''}"
          :fields="[
            {fieldName:'type', displayName:'Integration', type:'Enumerator', rules:[rules.required], values:getEnumArray(CloudIntegrationType)},
            {fieldName:'name', displayName:'Name', placeholder:'', type: String, rules:[rules.required] },
            {fieldName:'username', displayName:'UAID', placeholder:'', type: String, rules:[rules.required], displayCondition: o => o.type === 'YOLINK' },
            {fieldName:'password', displayName:'Secret Key', placeholder:'', type: String, rules:[rules.required], displayCondition: o => o.type === 'YOLINK' },
            ]"
          :save-method="(data) => this.$api.cloud.createCloudIntegration(household.id, data.name, data.type, data.username, data.password)"
          :cancel-callback="() => this.createCloudIntegrationDialog = false"
          :success-callback="(o) => {this.createCloudIntegrationDialog = false; $router.push('/h/' + household.id + '/cloud-integration/' + o.id)}"
          :focus-index="0"
        ></DynamicForm>
      </Card>
    </v-dialog>
    <v-dialog v-model="createTimersDialog" max-width="1023">
      <Card title="Create a set of Timers" icon="mdi-timer" inDialog>
        <DynamicForm
          :key="createTimersDialog"
          :object="{name: 'Timers'}"
          :fields="[
            {fieldName:'name', displayName:'Name', placeholder:'', type: String, rules:[rules.required] },
            ]"
          :save-method="(data) => this.$api.timer.createTimerHolder(household.id, data.name)"
          :cancel-callback="() => this.createTimersDialog = false"
          :success-callback="(o) => {this.createTimersDialog = false; $router.push('/h/' + household.id + '/timer/' + o.id)}"
          :focus-index="0"
        ></DynamicForm>
      </Card>
    </v-dialog>
  </div>
</template>

<script>
  import Card from '@/components/Card'
  import DynamicForm from '@/components/DynamicForm'
  import { CloudIntegrationType } from '@/api'
  export default {
    name: 'HouseholdAddApp',
    computed: {
      CloudIntegrationType () {
        return CloudIntegrationType
      },
      aiPresetOptions () {
        return this.aiPersonalityPresets.map((preset) => ({
          text: preset.type,
          value: preset.type
        }))
      }
    },
    props: ['household'],
    components: { DynamicForm, Card },

    data: () => ({
      aiPersonalityPresets: [],
      createListDialog: false,
      createNewtonDialog: false,
      createTimerDialog: false,
      createFinancialModuleDialog: false,
      createPropertyHolderDialog: false,
      createVehicleHolderDialog: false,
      createAIAssistantDialog: false,
      createCalendarsDialog: false,
      createCloudIntegrationDialog: false,
      createTimersDialog: false,
      rules: {
        required: value => !!value || 'Required',
        sixDigits: value => (!!value && value.length === 6) || 'Code must be 6 characters',
      }
    }),
    mounted() {
      this.$api.ai.getAIPersonalityPresets().then((presets) => {
        this.aiPersonalityPresets = presets
      })
      this.$emit('breadcrumbs', []);
      this.$emit('resetMenu');
    },
    methods: {
      applyAIPreset (mutableObject) {
        const preset = this.aiPersonalityPresets.find((candidate) => candidate.type === mutableObject.presetType)
        if (!preset)
          return
        mutableObject.personality = preset.personality
        mutableObject.recurringBehavior = preset.recurringBehavior
      }
    }
  }
</script>

<style scoped>

</style>
